// Canvas colour + motion constants ported 1:1 from the v10 prototype.
// Pure presentation — no game logic lives here.

export const COL = {
  mist: '#f8f7f2',
  field: '#efede4',
  fieldDeep: '#e8e6da',
  strip: '#3b3b3b',
  line: '#f8f7f2',
  slate: '#3b3b3b',
  slateSoft: '#9a9a92',
  paper: '#ffffff',
  coral: '#de4b39',
  ink: '#3b3b3b',
  water: '#c2dbe0',
} as const;

/** `prefers-reduced-motion` — read once; matches the prototype's `reduceMotion`. */
export const reduceMotion: boolean =
  typeof matchMedia === 'function' && matchMedia('(prefers-reduced-motion: reduce)').matches;

/** `#rrggbb` + alpha → `rgba(...)`, same helper as the prototype's `hexA`. */
export function hexA(hex: string, a: number): string {
  const r = parseInt(hex.slice(1, 3), 16), g = parseInt(hex.slice(3, 5), 16), b = parseInt(hex.slice(5, 7), 16);
  return `rgba(${r},${g},${b},${Math.max(0, a)})`;
}

/** Breathing 0..1 pulse used by threshold rings, warning rings, radar sweep — frozen mid-breath when motion is reduced. */
export function pulse(periodMs = 900, frozenAt = 0.5): number {
  if (reduceMotion) return frozenAt;
  return 0.5 + 0.5 * Math.sin(performance.now() / periodMs);
}
